import { useTranslation } from 'react-i18next';
import { Form, Button } from 'react-bootstrap';
import TabNavigation from './TabNavigation';
import ProgressBar from './ProgressBar';
import i18n from '../../i18n';
import './StepForm.css';

interface StepThreeProps {
    step: number;
    otp: string;
    isLoading: boolean;
    onOtpChange: (value: string) => void;
    onSubmit: () => void;
    hasError?: boolean;
    errorMessage?: string;
}

const StepThree = ({ step, otp, isLoading, onOtpChange, onSubmit, hasError, errorMessage }: StepThreeProps) => {
    const { t } = useTranslation();

    if (step !== 3) return null;

    return (
        <div className="content step-form-container">
            {/* Tab Navigation for Mobile */}
            <TabNavigation step={step} />

            {/* Desktop Progress Indicator */}
            <ProgressBar step={step} />

            {/* Main Content */}
            <div className="step-title-container">
                <div className="step-title">
                    {t('primotech.step3.title') || 'Enter OTP'}
                </div>
                <p className="step-description">
                    {t('primotech.step3.description') || 'Enter the 6-digit OTP sent to your phone'}
                </p>
            </div>

            {/* Form */}
            <Form style={{marginTop: '30px'}}>
                <Form.Group className="mb-4" controlId="formOtp">
                    <Form.Label className="form-label-custom">
                        {t('primotech.otp') || 'OTP Code'}
                    </Form.Label>
                    <div className={`form-input-wrapper ${i18n.language === 'ar' ? 'rtl' : ''}`}>
                        <div className="form-input-icon">🔐</div>
                        <Form.Control 
                            type="text" 
                            placeholder="------"
                            maxLength={6}
                            value={otp}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                onOtpChange(value);
                            }}
                            className={`form-input-otp ${i18n.language === 'ar' ? 'rtl' : ''}`}
                        />
                    </div>
                    {!hasError && (
                        <Form.Text className="form-hint">
                            💡 {t('primotech.otpHint') || '6-digit code'}
                        </Form.Text>
                    )}
                    {hasError && (
                        <Form.Text className="form-text-error">
                            {errorMessage}
                        </Form.Text>
                    )}
                </Form.Group>

                <Button 
                    variant="primary" 
                    type="button" 
                    onClick={onSubmit}
                    disabled={isLoading || otp.length !== 6}
                    className={`submit-button ${otp.length === 6 && !isLoading ? 'submit-button-active' : 'submit-button-disabled'}`}
                >
                    {!isLoading && (
                        <span className="submit-button-text">
                            {t('primotech.confirmPayment') || 'Confirm Payment'} {i18n.language === 'en' ? '→' : '←'}
                        </span>
                    )}
                    {isLoading && (
                        <span className="submit-button-text">
                            <span className="submit-button-loading-icon">⏳</span>
                            {t('primotech.button.wait') || 'Please wait...'}
                        </span>
                    )}
                </Button>
            </Form>

            {/* Security Badge */}
            <div className="security-badge">
                <p className="security-badge-text">
                    🔒 {t('primotech.security') || 'Your information is encrypted and secure'}
                </p>
            </div>
        </div>
    );
};

export default StepThree;
